import { render, staticRenderFns } from "./Section2nd.vue?vue&type=template&id=00a22f33&scoped=true&"
import script from "./Section2nd.vue?vue&type=script&lang=js&"
export * from "./Section2nd.vue?vue&type=script&lang=js&"
import style0 from "./Section2nd.vue?vue&type=style&index=0&id=00a22f33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a22f33",
  null
  
)

export default component.exports